<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Tài khoản hủy</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.cancelUserId"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in sourceOptions"
                      :key="item.id"
                      :label="item.user_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo hủy giao dịch</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              :row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Mã đặt phòng: hiển thị mã đặt phòng của phòng có giao dịch hủy
            </li>
            <li>Số phòng: Tên hạng phòng và số phòng</li>
            <li>Dịch vụ: Hiển thị dịch vụ có thao tác hủy</li>
            <li>Số tiền: Số tiền của giao dịch hủy</li>
            <li>Người dùng: Tài khoản thu ngân hủy giao dịch</li>
            <li>
              Thời gian tạo: Thời gian tạo giao dịch. Format: DDMMYYYY HHMMSS
            </li>
            <li>
              Thời gian hủy: Thời gian hủy giao dịch. Format: DDMMYYYY HHMMSS
            </li>
            <li>Lý do hủy: Lý do hủy giao dịch</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getCancelTransactionList,
  getCancelTransactionListExcel
} from '@/api/report_service/cancelTransactionReport'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'
import { getUserDepositApi } from '@/api/report_service/report_b'
import { downFile } from '@/utils/file-handler'

export default {
  components: {
    CalendarRange,
    SelectWithSearchTable,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        wrapText: true,
        autoHeight: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: [],
        cancelUserId: ''
      },
      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: [],
        cancelUserId: ''
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          flex: 1
        }
      ],

      columns: [
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          tooltipField: 'recode',
          minWidth: 100,
          maxWidth: 150,
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomNum'),
          field: 'roomNum',
          tooltipField: 'roomNum',

          minWidth: 140,
          maxWidth: 240,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.service'),
          field: 'service',
          tooltipField: 'service',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 150,
          maxWidth: 200
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.amountOfMoney'),
          field: 'money',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          minWidth: 100,
          maxWidth: 150
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.user'),
          field: 'user',
          tooltipField: 'user',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 140,
          maxWidth: 200
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.createDatetime'),
          field: 'createDate',
          tooltipField: 'createDate',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 200,
          maxWidth: 200
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.cancelDatetime'),
          field: 'cancelDate',
          tooltipField: 'cancelDate',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 200,
          maxWidth: 200
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.cancelReason'),
          field: 'reason',
          tooltipField: 'reason',

          sortable: false,
          minWidth: 100,
          flex: 1
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListUserCancel()
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    async getListUserCancel() {
      const data = await getUserDepositApi()
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.cancelUserId = val.id
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async attachData() {
      try {
        this.loading = true

        const data = await getCancelTransactionList(this.searchParams)
        this.loading = false
        // data?.data.forEach(element => {
        //   this.rows = [
        //     ...this.rows,
        //     element,
        //     {
        //       name: ['Ghi chú: ', element.note].join(' '),
        //       isFullWidthRow: true
        //     }
        //   ]
        // })
        this.rows = data.data
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.' + error.response.data.message)
        })
      } finally {
        this.loading = false
      }
    },
    async downloadExcel() {
      try {
        this.loading = true

        const data = await getCancelTransactionListExcel(this.searchParams)
        this.loading = false

        const date = this.$moment().format('DD-MM-YYYY')
        downFile(data, 'bao_cao_huy_giao_dich_' + date + '.xlsx')
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.' + error.response.data.message)
        })
      } finally {
        this.loading = false
      }
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
